module.exports = __webpack_public_path__ + "static/salonslider-05-min-c0f049458a23cbde5c8ba1c8ebfd41cb.jpg";